import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss, Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Heading from '@atlaskit/heading';
import { cssMap } from '@atlaskit/css';

import { ObjectCommentPageReactions } from './ObjectCommentPageReactions.tsx';

const commentHeaderContainerStyles = xcss({
	borderTop: `${token('border.width')} solid ${token('color.border')}`,
	background: 'color.text.inverse',
	height: '64px',
	width: '100%',
	display: 'flex',
	padding: 'space.200',
	justifyContent: 'space-between',
	alignItems: 'center',
	alignSelf: 'stretch',
});

const commentHeaderReactionsContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	alignSelf: 'stretch',
});

const i18n = defineMessages({
	objectCommentHeaderText: {
		id: 'object-comments.object-comment-header.text',
		defaultMessage: 'Comments',
		description:
			'The text is shown as a heading above the comments section on an object (e.g. a page or blog post) when the comments panel is visible. It labels the comments area for the reader.',
	},
});

const styles = cssMap({
	headerMessageStyle: {
		color: token('color.text.subtle'),
		font: token('font.heading.medium'),
		fontFamily: token('font.family.heading'),
		fontWeight: token('font.weight.medium'),
	},
});

export const ObjectCommentHeader = ({
	isOffline = false,
	showReactions,
}: {
	isOffline?: boolean;
	showReactions: boolean;
}) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={commentHeaderContainerStyles}>
			<Heading size="medium" as="h2">
				<Box xcss={styles.headerMessageStyle}>{formatMessage(i18n.objectCommentHeaderText)}</Box>
			</Heading>
			{showReactions && (
				<Box xcss={commentHeaderReactionsContainerStyles}>
					<ObjectCommentPageReactions isOffline={isOffline} />
				</Box>
			)}
		</Box>
	);
};
